module.exports = __webpack_public_path__ + "img/banner-tc3-m.f2289559.jpg";